export default __webpack_public_path__ + "7c2e90d2a070643e6df29b3922cdec7d.png";